import React from "react";
import { foodBg } from "../../assets/images";

/**
 * Écran de chargement global
 * Affiche un spinner jusqu'à ce que les ressources (auth, traductions, etc.) soient prêtes
 */
const AppLoadingScreen = ({ message = "Chargement...", subMessage }) => {
  const logoUrl = process.env.PUBLIC_URL
    ? `${process.env.PUBLIC_URL}/logojes.png`
    : "/logojes.png";

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4 overflow-hidden">
      {/* Fond */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${foodBg})` }}
        aria-hidden
      />
      <div className="fixed inset-0 z-0 bg-slate-900/50" aria-hidden />

      {/* Carte glass centrée */}
      <div className="relative z-10 w-full max-w-sm sm:max-w-md">
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 overflow-hidden">
          <div
            className="h-1.5 sm:h-2 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-500"
            aria-hidden
          />
          <div className="px-8 sm:px-10 py-10 sm:py-12 flex flex-col items-center gap-8">
            <div className="flex flex-col items-center gap-4">
              <img
                src={logoUrl}
                alt="JesCook"
                className="h-14 w-auto sm:h-16 object-contain drop-shadow-lg"
              />
              <h1 className="text-xl sm:text-2xl font-bold text-white tracking-tight">
                JesCook
              </h1>
              <p className="text-white/80 text-xs sm:text-sm font-medium -mt-2">
                Vos recettes, votre monde
              </p>
            </div>

            <div className="flex flex-col items-center gap-5">
              <div className="relative">
                <div
                  className="w-14 h-14 sm:w-16 sm:h-16 rounded-full border-2 border-white/20 border-t-orange-500 border-r-amber-400 animate-spin"
                  aria-hidden
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-orange-400/80 text-lg sm:text-xl">
                    🍳
                  </span>
                </div>
              </div>
              <div className="text-center">
                <p className="text-white font-medium text-sm sm:text-base">
                  {message}
                </p>
                {subMessage && (
                  <p className="text-white/60 text-xs sm:text-sm mt-1">
                    {subMessage}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full max-w-[200px] h-1.5 bg-white/10 rounded-full overflow-hidden">
              <div
                className="h-full w-1/3 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full"
                style={{
                  animation: "appLoadingBar 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`@keyframes appLoadingBar { 0%, 100% { transform: translateX(-100%); } 50% { transform: translateX(250%); } }`}</style>
    </div>
  );
};

export default AppLoadingScreen;
